// extracted by mini-css-extract-plugin
module.exports = {"editor":"FloorplanVisualizer_editor__3OGiT"};